import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.network.dns.zone.formatAsBind;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_ZONE_FORMATASBIND',
	method: 'POST',
	url: '/network/dns/zone/formatAsBind.json',
});

const selectors = {
	bindData: createSelector(
		defaultSelectors.getData,
		(data) => data && data.get('bind_data'),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
